var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"landing-avatar",style:(_vm.imageStyles)},[_c('img',{staticClass:"landing-avatar__image",attrs:{"src":_vm.src,"alt":"avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }